import applySidebarOrganizationOperation from './applySidebarOrganizationOperation.js';

const applySidebarOrganizationOperations = ({ snapshot, pendingMutations = [] } = {}) => {
  return pendingMutations.reduce((current, pendingMutation) => {
    return applySidebarOrganizationOperation({ snapshot: current, operation: pendingMutation.operation });
  }, snapshot);
};

export default applySidebarOrganizationOperations;
